import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {UpdateComplianceForm} from "../../../forms/update-compliance-form";

export const EditBrandComplianceTab = () => {

  const workspaceId = useGetCurrentWorkspaceId();

  return <UpdateComplianceForm organizationId={workspaceId} />
}
